import { MdClose } from 'react-icons/md';
import { FaCrown } from 'react-icons/fa';
import { goToPremium } from '@/lib/premium';

interface PremiumRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
  featureTitle: string;
  featureDescription: string;
  benefits?: string[];
  additionalNote?: string;
}

export const PremiumRequiredModal = ({
  isOpen,
  onClose,
  featureTitle,
  featureDescription,
  benefits = [],
  additionalNote,
}: PremiumRequiredModalProps) => {
  if (!isOpen) return null;

  const defaultBenefits = [
    'Acceso a funciones avanzadas',
    'Soporte prioritario',
    'Actualizaciones exclusivas',
  ];

  const displayBenefits = benefits.length > 0 ? benefits : defaultBenefits;

  const handleVerPlanes = () => {
    onClose();
    goToPremium();
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header con gradiente */}
        <div className="px-6 py-6 bg-gradient-to-r from-purple-500 to-pink-500 rounded-t-2xl">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                <FaCrown className="text-2xl text-purple-500" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white">
                  Función Premium
                </h2>
                <p className="text-sm text-purple-100">
                  Desbloquea más posibilidades
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-lg hover:bg-white/20 transition-colors"
            >
              <MdClose className="text-2xl text-white" />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 py-6">
          <div className="mb-6">
            <h3 className="text-lg font-bold text-gray-800 mb-2">
              {featureTitle}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {featureDescription}
            </p>
          </div>

          <div className="mb-6 p-4 bg-purple-50 border-2 border-purple-200 rounded-lg">
            <h4 className="font-semibold text-purple-900 mb-2 flex items-center gap-2">
              <span className="text-xl">✨</span>
              Beneficios
            </h4>
            <ul className="space-y-2 text-sm text-purple-800">
              {displayBenefits.map((benefit, index) => (
                <li key={index} className="flex items-start gap-2">
                  <span className="text-green-600 font-bold">✓</span>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>

          {additionalNote && (
            <p className="text-sm text-gray-500 mb-6">
              <strong>Nota:</strong> {additionalNote}
            </p>
          )}

          <button
            onClick={handleVerPlanes}
            className="w-full py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg font-bold text-lg hover:from-purple-600 hover:to-pink-600 transition-all hover:scale-105 active:scale-95"
          >
            Ver Planes
          </button>
        </div>
      </div>
    </div>
  );
};
